module.exports = __webpack_public_path__ + "img/broadcast-work-icon5.edbd9a19.png";